// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rejection-reason__date-picker[data-v-2ce8f575] {\n  margin: 16px 0 32px 0;\n  margin-top: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
